import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  form: {
    width: '100%',
    color: colors.neutral[900],
  },
  formElements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  input: { width: '100%' },
  formFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '2rem',
    flexWrap: 'wrap',
    padding: '6rem 0 1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
